import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../api/client";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  // La pornire: dacă există o sesiune validă (cookie), încarcă utilizatorul.
  useEffect(() => {
    api
      .get("/api/auth/me")
      .then((d) => {
        setUser(d.user);
        setPermissions(d.permissions);
      })
      .catch(() => {
        // neautentificat — starea rămâne goală
      })
      .finally(() => setLoading(false));
  }, []);

  // Sesiune expirată/invalidată de backend → delogare silențioasă
  useEffect(() => {
    const onUnauthorized = () => {
      setUser(null);
      setPermissions([]);
    };
    window.addEventListener("auth:unauthorized", onUnauthorized);
    return () => window.removeEventListener("auth:unauthorized", onUnauthorized);
  }, []);

  const login = useCallback(async (email, password) => {
    const d = await api.post("/api/auth/login", { email, password });
    setUser(d.user);
    setPermissions(d.permissions);
    return d;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/api/auth/logout");
    } catch {
      // sesiunea oricum dispare local
    }
    setUser(null);
    setPermissions([]);
  }, []);

  // Reîncarcă utilizatorul (ex: după schimbarea parolei forțate)
  const refresh = useCallback(async () => {
    const d = await api.get("/api/auth/me");
    setUser(d.user);
    setPermissions(d.permissions);
    return d;
  }, []);

  // Verificare permisiune după matricea de acces (meniul se ascunde, dar
  // backend-ul verifică oricum fiecare endpoint).
  const hasPerm = useCallback(
    (perm) => permissions.includes(perm),
    [permissions]
  );
  const hasAnyPerm = useCallback(
    (perms) => perms.some((p) => permissions.includes(p)),
    [permissions]
  );

  return (
    <AuthContext.Provider value={{ user, permissions, loading, login, logout, refresh, hasPerm, hasAnyPerm }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth trebuie folosit în interiorul AuthProvider");
  return ctx;
}
